<div class="page-container">
  <div class="greet-container">
    <p class="user-header">
      Hello, {{ authenticationService.profile?.givenName }}
    </p>
    <h1 class="welcome-heading">Welcome to</h1>
    <h1 class="heading-banner-text">EY Corporate Income Tax (CIT) Agent</h1>
  </div>

  <div class="cards-wrapper">
    <button
      motifIconButton
      class="scroll-button left"
      *ngIf="showScrollLeft && !isZoomed"
      (click)="scrollCards('left')"
      [tabIndex]="0"
      aria-label="Scroll cards to the left"
      aria-live="polite"
    >
      <motif-icon size="18" [iconFunction]="IconoirNavArrowLeft"></motif-icon>
    </button>

    <div
      #cardsContainer
      class="cards-container"
      [ngClass]="{
        'is-scrollable': isScrollable && !isZoomed,
        'column-flex': isZoomed
      }"
    >
      <motif-card
        orientation="vertical"
        cardVariant="card-border"
        class="card"
        *ngFor="let card of cards; let i = index"
      >
        <!-- <span role="text" class="motif-body2-default-regular span-role-text">
          {{ card.agent }}
        </span> -->
        <motif-card-header [attr.aria-level]="null">
          <div class="motif-card-subheader">
            <h2
              class="motif-h6-default-regular negative-margin"
              [ngClass]="{ 'two-line': card.twoLineHeader }"
              [innerHTML]="card.header"
            ></h2>
          </div>
        </motif-card-header>
        <motif-card-body [innerHTML]="card.content"></motif-card-body>
        <motif-card-footer>
          <motif-button
            variant="primary-alt"
            full-width="true"
            (click)="card.action()"
            size="lg"
            [ariaLabel]="card.header + ' Get Started'"
            aria-live="polite"
          >
            Get Started
          </motif-button>
        </motif-card-footer>
      </motif-card>
    </div>

    <button
      motifIconButton
      class="scroll-button right"
      *ngIf="showScrollRight && !isZoomed"
      (click)="scrollCards('right')"
      [tabIndex]="0"
      aria-label="Scroll cards to the right"
      aria-live="polite"
    >
      <motif-icon size="18" [iconFunction]="IconoirNavArrowRight"></motif-icon>
    </button>
  </div>
  <!--  -->
</div>
